
.app-body
  .row
    .col-sm-10
      h1 {{ $tc('js.award.title', countFull, { firma: firma, count: countFull }) }}
    .col-sm-2
      img.img-responsive.pull-right(:src="logo")
  br
  p {{ $t('js.award.body', bodyI18nArgs) }}
  br
  br
  .row.top-row
    .col-lg-4.col-12
      card(
        :id='id'
        color='#532080'
        :title="$t('js.award.satisfaction_process.title')"
        :subtitle="$t('js.award.satisfaction_process.subtitle')"
        icon="fa-star-half-o"
        type="cxp_public_score:satisfaction_process"
        :scale="true"
        v-model="satisfaction_process"
      )
    .col-lg-4.col-12
      card(
        :id='id'
        color='#532080'
        :title="$t('js.award.would_recommend.title')"
        :subtitle="$t('js.award.would_recommend.subtitle')"
        icon="fa-comment-o"
        v-model="would_recommend"
        type="cxp_public_score:would_recommend"
      )
    .col-lg-4.col-12
      card(
        :id='id'
        color='#532080'
        :title="$t('js.award.award.title')"
        icon="fa-trophy"
        :custom="true"
      )
        .row
          .col-sm-4
            img.img-responsive(:src="image" width="130")
          .col-sm-8
            .satisfaction(v-html="satisfaction")
            strong  {{ $tc('js.award.award.this_year', count, { count: count }) }}
            br
            .text-muted {{ $tc('js.award.award.one_year_ago', countOneYearAgo, { count: countOneYearAgo }) }}
  .row
    .col-md-6.col-lg-3
      card(
        :id='id'
        color='#b779f2'
        :title="$t('js.award.first_contact.title')"
        :subtitle="$t('js.award.first_contact.subtitle')"
        icon="fa-handshake-o"
        prefix="r"
        :scale="true"
        type="cxp_public_score:satisfaction_first_contact"
        v-model="first_contact"

      )
    .col-sm-6.col-lg-3
      card(
        :id='id'
        color='#b779f2'
        :title="$t('js.award.interview.title')"
        :subtitle="$t('js.award.interview.subtitle')"
        prefix="s"
        icon="fa-comments-o"
        :scale="true"
        type="cxp_public_score:satisfaction_with_interview"
        v-model="interview"
      )
    .col-md-6.col-lg-3
      card(
        :id='id'
        color='#b779f2'
        :title="$t('js.award.rejection.title')"
        :subtitle="$t('js.award.rejection.subtitle')"
        icon="fa-times"
        :scale="true"
        type="cxp_public_score:satisfaction_with_rejection"
        v-model="rejection"
      )
    .col-md-6.col-lg-3
      card(
        :id='id'
        color='#b779f2'
        :title="$t('js.award.negotiation.title')"
        :subtitle="$t('js.award.negotiation.subtitle')"
        icon="fa-check"
        :scale="true"
        type="cxp_public_score:satisfaction_with_negotiation"
        v-model="negotiation"
      )

